import { HorizontalBar} from 'vue-chartjs'
import { Agent } from 'http'
import moment from "moment";
import localization from 'moment/locale/de';
moment.locale('de', localization);

export default {
  extends: HorizontalBar,
  props: ['lz'],
  data() {
    let adrs = this.lz.map(el => el.adresse.split(' ').slice(0, 4).join(' '))
    let vals = this.lz.map(el => el.zeitraum)
    return {
      chartdata: {
        labels: adrs,
        datasets: [{
          label: 'Leistungszeitraum',
          data: vals,
          barThickness: 4,
          minBarLength: 5,
          backgroundColor: '#36a2eb',
        }]
      },
      options: {
        responsive: true,
        offset: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: true,
          backgroundColor: '#2c3e50',
          callbacks: {
            label: function(tooltipItem, data) {
              let date = data.datasets[0].data[tooltipItem.index]
              let x = ["Beginn: " + moment(date[0]).format('DD.MM.YYYY'), "Ende: " + moment(date[1]).format('DD.MM.YYYY')]
              return x
            }
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              fontFamily: "Avenir",
              min: moment(),
              max: moment().add(4, 'year')
            },
            type: 'time',
            time: {
              unit: 'year',
            },
            gridLines: {
              lineWidth: 1,
              color: '#757575'
            },
          },
          {
            ticks: {
              fontFamily: "Avenir",
              min: moment(),
              max: moment().add(4, 'year')
            },
            type: 'time',
            time: {
              unit: 'month',
              displayFormats: {
                month: 'MMM YY',
              }
            }
          },
          ],
          yAxes: [{
            ticks: {
              fontFamily: "Avenir",
              fontSize: 8
            },
          }]
        },
        legend: {
          display: false,
          labels: {
            fontFamily: "Avenir",
          }
        }
      }
    }
  },
  mounted() {
    this.renderChart(this.chartdata, this.options)
  }
}